var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M22 12.2316C22 11.5589 21.9404 10.9204 21.8382 10.2988H12.2172V14.1387H17.7259C17.479 15.3988 16.7552 16.4631 15.6825 17.1868V19.7411H18.9689C20.8932 17.9616 22 15.3392 22 12.2316Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.2199 22.2165C14.9785 22.2165 17.2859 21.297 18.9717 19.7389L15.6852 17.1846C14.7657 17.7976 13.5992 18.1723 12.2199 18.1723C9.55498 18.1723 7.29871 16.3758 6.48986 13.9492H3.1012V16.5801C4.7785 19.9177 8.22676 22.2165 12.2199 22.2165Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.48712 13.9484C6.27426 13.3354 6.16358 12.6798 6.16358 11.9986C6.16358 11.3175 6.28278 10.6619 6.48712 10.0489V7.41797H3.09846C2.40029 8.79727 2.00012 10.3469 2.00012 11.9986C2.00012 13.6504 2.40029 15.2 3.09846 16.5793L6.48712 13.9484Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.2199 5.82746C13.7269 5.82746 15.0722 6.34683 16.1365 7.36002L19.0483 4.44816C17.2859 2.7964 14.9785 1.7832 12.2199 1.7832C8.22676 1.7832 4.7785 4.08205 3.1012 7.41962L6.48986 10.0505C7.29871 7.62396 9.55498 5.82746 12.2199 5.82746Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4477871a9c713344702e0ca97108c3d8.svg";
export { ForwardRef as ReactComponent };